export enum LanguageTypes {
  English = 'en',
  Spanish = 'es',
  Portuguese = 'pt',
}
